var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulbicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2020_34236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7.5C1.27539 3.63401 4.4094 0.5 8.27539 0.5H42.2754C46.1414 0.5 49.2754 3.63401 49.2754 7.5V41.5C49.2754 45.366 46.1414 48.5 42.2754 48.5H8.27539C4.4094 48.5 1.27539 45.366 1.27539 41.5V7.5Z",
    fill: "url(#paint0_linear_2020_34236)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2754 34.5C24.8421 34.5 24.4504 34.3958 24.1004 34.1875C23.7504 33.9792 23.4754 33.7 23.2754 33.35C22.7254 33.35 22.2546 33.1542 21.8629 32.7625C21.4712 32.3708 21.2754 31.9 21.2754 31.35V27.8C20.2921 27.15 19.5046 26.2917 18.9129 25.225C18.3212 24.1583 18.0254 23 18.0254 21.75C18.0254 19.7333 18.7296 18.0208 20.1379 16.6125C21.5462 15.2042 23.2587 14.5 25.2754 14.5C27.2921 14.5 29.0046 15.2042 30.4129 16.6125C31.8212 18.0208 32.5254 19.7333 32.5254 21.75C32.5254 23.0333 32.2296 24.2 31.6379 25.25C31.0462 26.3 30.2587 27.15 29.2754 27.8V31.35C29.2754 31.9 29.0796 32.3708 28.6879 32.7625C28.2962 33.1542 27.8254 33.35 27.2754 33.35C27.0754 33.7 26.8004 33.9792 26.4504 34.1875C26.1004 34.3958 25.7087 34.5 25.2754 34.5ZM23.2754 31.35H27.2754V30.45H23.2754V31.35ZM23.2754 29.45H27.2754V28.5H23.2754V29.45ZM26.0254 26.5V23.8L28.2254 21.6L27.1754 20.55L25.2754 22.45L23.3754 20.55L22.3254 21.6L24.5254 23.8V26.5H26.0254Z",
    fill: "#E6F2FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2020_34236",
    x: 0.275391,
    y: 0.5,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2020_34236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2020_34236",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2020_34236",
    x1: 25.2754,
    y1: 0.5,
    x2: 25.2754,
    y2: 48.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbicon);
export default __webpack_public_path__ + "static/media/light+bulb+icon.1cceaafddd598e113127a984ad30b34e.svg";
export { ForwardRef as ReactComponent };